import gql from "graphql-tag";

export const NEWSLETTER_CONFIRM_EMAIL = gql`
  mutation confirmEmailToNewsletter($id: String!, $code: String!) {
  confirmEmailToNewsletter(id: $id, code: $code) {
    status
    message
  }
}
`;